import { useTranslation } from "react-i18next";
import { CheckableRowBody } from "../../../../components/RowValue/CheckableRowBody";

export default function ExecutionStatistics({ isChecked, onChecked }) {
  const { t } = useTranslation("translation");

  return (
    <CheckableRowBody
      isChecked={isChecked}
      onChecked={onChecked}
      titleValue={<p>{t("lvText.positionRequirements.executionStatistics")}</p>}
    />
  );
}
